import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={931}
    height={777}
    viewBox="0 0 931 777"
    fill="none"
    {...props}
  >
    <g opacity={0.1}>
      <path
        fill="#EC7760"
        d="M582.67 755.17 414.65 587.16h.05l167.97 168.01Z"
      />
      <path
        fill="#222221"
        d="M580.15 774.56c-1.52.19-3.05.33-4.62.43l.05.05 4.48-.43c3.24-.33 6.48-.67 9.72-1.05l-9.62 1h-.01Z"
      />
      <path
        fill="#EC7760"
        d="M930.28 388.23c0 97.06-36.05 189.97-101.44 261.6-60.48 66.34-141.21 109.3-229.12 122.35l-8.48-8.48-8.52-8.52h-.05L414.7 587.16h-.05l-9.48-9.52-9.57-9.52h146.49c99.15 0 179.83-80.67 179.83-179.88 0-48.01-18.72-93.15-52.67-127.11-34-34-79.15-52.72-127.16-52.72H395.6L215.77 388.24h-294.7l9.52-9.52 3.95-3.91L54.93 254.37l6.71-6.71L309.31 0H542c214.07 0 388.28 174.16 388.28 388.23Z"
      />
      <path
        fill="#435288"
        d="m68.42 240.88-6.76 6.76-6.71 6.71-120.39 120.44-3.95 3.91-9.52 9.52-179.83-179.83-9.57-9.52-177.65-177.63-8.57-8.57-8.48-8.48c6.53-.95 13.1-1.76 19.67-2.38 1.48-.14 3-.29 4.53-.38C-427.95.48-416.86 0-405.76 0h233.26L68.43 240.88h-.01Z"
      />
      <path
        fill="#222221"
        d="M599.72 772.18c-3.19.48-6.43.95-9.67 1.33l9.95-1.05-.29-.29.01.01ZM414.7 587.16h-.05l168.02 168.02L414.7 587.16Z"
      />
      <path
        fill="#435288"
        d="M599.72 772.18c-3.19.48-6.43.95-9.67 1.33l-.29.05-9.62 1c-1.52.19-3.05.33-4.62.43-10.81 1.05-22.05 1.52-33.53 1.52H309.3L68.42 535.63l6.72-6.76 6.76-6.72 120.39-120.44 3.95-3.95 2.81-2.76 6.72-6.76L395.6 568.12l9.57 9.52 9.48 9.52 168.02 168.02h.05l8.52 8.52 8.48 8.48Z"
      />
      <path
        fill="#6AE5BC"
        d="m215.77 388.23-6.72 6.76-2.81 2.76-3.95 3.95L81.9 522.14l-6.76 6.72-6.72 6.76-240.93 240.88h-233.26C-619.84 776.51-794 602.35-794 388.23c0-103.68 40.39-201.21 113.73-274.6 58.91-58.86 135.44-97.3 217.26-109.44l8.48 8.48 8.57 8.57 177.64 177.64 9.57 9.52h-147.11c-99.15 0-179.83 80.67-179.83 179.83 0 48.05 18.72 93.2 52.67 127.16 34 34 79.15 52.72 127.16 52.72h147.06l179.88-179.88h294.7-.01Z"
      />
    </g>
  </svg>
)
export default SvgComponent
